import { ToastNotificationTypes, useToastNotifications } from "@/composables/useToastNotifications";

const { displayNotificationWithOptions } = useToastNotifications();

const testingRewardThresholds = import.meta.env.VITE_REWARD_THRESHOLDS;

const thresholds = testingRewardThresholds?.split(",").map(Number) || [
  7000, 6000, 5500, 5000, 4500, 3700, 2500, 1500, 800, 200,
];

const NUMBER_OF_MESSAGES = 6;
const rollDice = () => Math.floor(Math.random() * NUMBER_OF_MESSAGES) + 1;

export const checkResetRewardCounter = () => {
  const today = new Date().toDateString();
  const lastResetDate = localStorage.getItem("lastRewardCounterResetDate");
  if (lastResetDate !== today) {
    localStorage.setItem("rewardCounter", "0");
    localStorage.setItem("lastRewardCounterResetDate", today);
  }
};

export const incrementRewardCounter = (numberOfComments: number) => {
  checkResetRewardCounter();
  const oldValueRewardCounter = Number(localStorage.getItem("rewardCounter"));
  const newCommentCount = numberOfComments + oldValueRewardCounter;
  localStorage.setItem("rewardCounter", newCommentCount.toString());

  for (const threshold of thresholds) {
    if (oldValueRewardCounter < threshold && threshold <= newCommentCount) {
      displayNotificationWithOptions({
        type: ToastNotificationTypes.REWARD,
        title: { i18n: [`general.notifications.reward.${rollDice()}.title`] },
        label: { i18n: [`general.notifications.reward.${rollDice()}.text`, threshold] },
        duration: 10000,
      });
      break;
    }
  }
};
